import { TextInput } from '@labrav/react-components'
import { Box } from '@labrav/react-components'
import React from 'react'
import { useStyles } from './Buyer.styles'
import { KeyValue } from '../../../../modules/privateOffer/privateOfferCreation/types'
import { isEmpty } from 'lodash'

export type BuyerProps = {
  buyerAwsAccountId: string
  error: string
  handleChange: (data: KeyValue) => void
}
export const Buyer: React.FC<BuyerProps> = ({
  handleChange,
  buyerAwsAccountId,
  error,
}) => {
  const { classes } = useStyles()
  const handleUpdate = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleChange({
      key: 'buyerAwsAccountId',
      value: (event.target as HTMLInputElement).value,
    })
  }
  return (
    <Box heading={'Buyer(s)'} subHeading={''}>
      <div className={classes.buyerFieldContainer}>
        <TextInput
          keyName="buyerAwsAccountId"
          title="Buyer AWS account ID"
          placeHolder=""
          isRequired={false}
          type="number"
          isReadOnly={false}
          value={buyerAwsAccountId}
          isError={!isEmpty(error)}
          onChange={handleUpdate}
          errorText={error}
        />
      </div>
    </Box>
  )
}
